import { Style } from "./Style";
import { FetchWithAuth } from "digimaker-ui/util";
import { useEffect } from "react";
import { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import FileUpload from "digimaker-ui/FileUpload";
import { useSearchParams } from "react-router-dom";
import { Button, Table } from "react-bootstrap";
import { getYears, names } from "./years";

const Edit = (props: { id: any; mode: "edit" | "create" }) => {
  const mode = props.mode;

  const nav = useNavigate();
  const [params, setParams] = useSearchParams();
  const from = params.get("from");
  const [year, setYear] = useState("");

  const [list, setList] = useState<
    Array<{
      name?: string;
      customName?: string;
      path: string;
    }>
  >([]);

  useEffect(() => {
    if (mode === "edit") {
      FetchWithAuth(`content/get/${props.id}`)
        .then((data) => {
          if (data.error === false) {
            setYear(data.data.year.value);
            setList(data.data.body);
          }
        })
        .catch((d) => {
          window.alert(d.message);
          nav(`/`);
        });
    } else {
      setList([{ name: "file1", customName: "", path: "" }]);
    }
  }, [props.id]);

  const deleteItem = (i: number) => {
    const newList = [...list];
    newList.splice(i, 1);
    setList(newList);
  };

  const updateItem = (index: number, value: any) => {
    const newList = [...list];
    newList[index] = { ...newList[index], ...value };
    setList(newList);
  };

  const save = (data) => {
    if (year === "") {
      alert("Please select a year");
      return;
    }
    console.log(data);
    const jsonData = {
      year: data.page.year,
      body: list,
    };

    if (mode === "edit") {
      FetchWithAuth(`content/update/${props.id}`, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(jsonData),
      })
        .then(() => {
          nav(from ? "/website" + from : "/");
        })
        .catch((d) => {
          window.alert(d.message);
          nav(`/`);
        });
    } else {
      FetchWithAuth("content/create/annual_report/" + props.id, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(jsonData),
      })
        .then(() => {
          nav(from ? "/website" + from : "/");
        })
        .catch((d) => {
          window.alert(d.message);
          nav(`/`);
        });
    }
  };

  return (
    <form
      style={{ ...Style.container, flexDirection: "column" }}
      onSubmit={(e) => {
        e.preventDefault();
        save({ page: { year: year } });
      }}
    >
      <h2>{mode === "edit" ? "Redigere" : "Opprette"} årsmøte</h2>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ marginRight: 10 }}>År:</div>
        <select
          style={Style.select}
          name="year"
          value={year}
          onChange={(e) => setYear(e.target.value)}
        >
          <option value="">Velg</option>
          {getYears().map((item) => (
            <option value={item}>{item}</option>
          ))}
        </select>
      </div>

      <label>Filer:</label>
      <Table>
        <thead>
          <th>Navn</th>
          <th>Fil</th>
          <th></th>
        </thead>

        <tbody>
          {list.map((item, index: number) => (
            <tr key={item.path + index}>
              <td>
                <select
                  value={item.name || ""}
                  onChange={(e) => updateItem(index, { name: e.target.value })}
                >
                  <option value="">Annet</option>
                  {Object.keys(names).map((item) => (
                    <option value={item}>{names[item]}</option>
                  ))}
                </select>
                {item.name === "" && (
                  <input
                    placeholder="Vennligst skriv inn"
                    style={{ marginTop: 2 }}
                    className="form-control"
                    defaultValue={item.customName}
                    onChange={(e) =>
                      updateItem(index, { customName: e.target.value })
                    }
                  />
                )}
              </td>
              <td>
                {" "}
                <FileUpload
                  value={item.path}
                  name={"file" + index}
                  service="content"
                  format={"pdf"}
                  onSuccess={(info) => {
                    console.log(info);
                    updateItem(index, { path: info.nameUploaded });
                  }}
                />
              </td>
              <td>
                <Button
                  variant="link"
                  size="sm"
                  title="Delete"
                  onClick={() => deleteItem(index)}
                >
                  <i className="fa fa-trash"></i>
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <div className="text-right">
        <Button
          variant="secondary"
          size="sm"
          onClick={() =>
            setList([...list, { name: "", customName: "", path: "" }])
          }
        >
          {" "}
          + Legg til
        </Button>
      </div>
      <br />
      <div>
        <Button size="sm" type="submit" name="submit">
          Send
        </Button>
        &nbsp;
        <Button
          size="sm"
          variant="light"
          onClick={() => nav(from ? "/website" + from : "/")}
        >
          Tilbake
        </Button>
      </div>
    </form>
  );
};

export default Edit;
